module.exports = __webpack_public_path__ + "img/projectTitle.00d3b7a3.png";